import ellide from "../ellide";
import pure from "./higher-order/pure";
import React from "react";

const maxRows = 5;

export default pure(function TicketTable({ tickets, users }) {
  var col1 = tickets.take(maxRows);
  if (tickets.count() <= maxRows) {
    return <SimpleTicketTable tickets={col1} users={users} />;
  }

  var col2 = tickets.skip(maxRows).take(maxRows);

  var others;
  if (tickets.count() > maxRows * 2) {
    others = (
      <p className="margin-top--is-5">
        +
        {tickets.count() - (2 * maxRows)}

        {" "}
        Others
      </p>
    );
  }

  return (
    <div>
      <div className="batch-g">
        <div className="batch-c-1-2 border-right--width-1">
          <SimpleTicketTable shortenUsername tickets={col1} users={users} />
        </div>

        <div className="batch-c-1-2">
          <SimpleTicketTable shortenUsername tickets={col2} users={users} />
        </div>
      </div>

      {others}
    </div>
  );
});

var SimpleTicketTable = pure(function SimpleTicketTable({ shortenUsername, tickets, users }) {
  if (tickets.count() === 0) {
    return null;
  }
  var rows = tickets.map((ticket) => <SimpleTicketTableRow key={ticket.get("id")} shortenUsername={shortenUsername} ticket={ticket} users={users} />);
  return (
    <table className="table--padding-is-small table--border-is-none table-layout--is-auto width--is-auto">
      <thead>
        <tr>
          <th className="text-center">
            Rank
          </th>

          <th>
            Player
          </th>
        </tr>
      </thead>

      <tbody>
        {rows}
      </tbody>
    </table>
  );
});

var SimpleTicketTableRow = pure(function SimpleTicketTableRow({ shortenUsername, ticket, users }) {
  var user = users.get(ticket.get("user_id"));
  var username = user.get("username");
  if (shortenUsername) {
    username = ellide(username, 10);
  }
  return (
    <tr key={ticket.ticketId}>
      <td className="text-center">
        {ticket.get("rank")}
      </td>

      <td>
        {username}

        {" "}
        (

        {ticket.get("ticket_number")}
        )
      </td>
    </tr>
  );
});
